export default "__VITE_PUBLIC_ASSET__55b126e4__"